/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import PropTypes from 'prop-types';

import type { Theme } from '@coursera/cds-core';
import { withTheme } from '@coursera/cds-core';

import { SearchBar } from 'bundles/discussions/components/personalization-Search';
import { getCourseDiscussionsSearchUrl } from 'bundles/discussions/utils/discussionsUrl';


type Props = {
  animateToSearch: () => void;
  animateFromSearch: () => void;
  nextElementId?: string;
  previousElementId?: string;
  theme: Theme;
  placeholder?: string;
  onSubmit: (q: string) => void;
};

type State = {
  query: string;
};

const styles = (theme: Theme) => css`
  position: relative;

  .search-box {
    width: 100%;

    &:hover {
      outline: none;
    }
  }

  .search-bar {
    border: 1px solid ${theme.palette.gray[500]};
  }
`;

class SearchBox extends React.Component<Props, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  state = {
    query: '',
  };

  handleQueryChange = (newQuery: string) => {
    this.setState({
      query: newQuery,
    });
  };

  handleFocus = () => {
    const { animateToSearch } = this.props;
    animateToSearch();
  };

  handleBlur = () => {
    const { animateFromSearch } = this.props;
    animateFromSearch();
  };

  handleClear = () => {
    this.setState({
      query: '',
    });
  };

  handleTab = (e: React.KeyboardEvent<HTMLElement>) => {
    const { nextElementId } = this.props;
    const element = nextElementId && document && document.getElementById(nextElementId);
    if (element) {
      e.preventDefault();
      element.focus();
    }
  };

  handleShiftTab = (e: React.KeyboardEvent<HTMLElement>) => {
    const { previousElementId } = this.props;
    const element = previousElementId && document && document.getElementById(previousElementId);
    if (element) {
      e.preventDefault();
      element.focus();
    }
  };

  submitSearch = () => {
    const { query } = this.state;
    const { router } = this.context;
    const { onSubmit } = this.props;
    const discussionsPathTest = /discussions\/(forums|weeks|groups)\//i;
    const isValidForumPath = discussionsPathTest.test(router.location.pathname);

    if (query) {
      const {
        location: { pathname },
      } = router;
      const q = query.replace('*', '');
      const routerFunc = (pathName: $TSFixMe) => {
        return router.push({
          pathname: pathName,
          params: {},
          query: { q },
        });
      };
      if (isValidForumPath) {
        routerFunc(pathname);
        onSubmit(q);
      } else {
        routerFunc(getCourseDiscussionsSearchUrl());
      }
    }
  };

  render() {
    const { query } = this.state;
    const { placeholder } = this.props;
    return (
      <SearchBar
        query={query}
        handleSubmit={this.submitSearch}
        handleChange={this.handleQueryChange}
        handleBlur={this.handleBlur}
        handleShiftTab={this.handleShiftTab}
        handleTab={this.handleTab}
        handleClear={this.handleClear}
        focus
        css={styles(this.props.theme)}
        placeholder={placeholder}
      />
    );
  }
}

export default withTheme(SearchBox);
